const StatusBadge = ({ status }) => {
  const config = {
    active:    { bg: '#086F3C', icon: 'bi-door-open',    label: 'Active' },
    completed: { bg: '#6c757d', icon: 'bi-check-circle', label: 'Checked Out' },
    cancelled: { bg: '#dc3545', icon: 'bi-x-circle',     label: 'Cancelled' },
  };
  const { bg, icon, label } = config[status] || { bg: '#6c757d', icon: 'bi-question-circle', label: status };
  return (
    <span className="badge d-inline-flex align-items-center gap-1"
      style={{ backgroundColor: bg, fontWeight: 600, padding: '0.35em 0.65em' }}>
      <i className={`bi ${icon}`}></i> {label}
    </span>
  );
};

export default StatusBadge;